var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var _require = require('./grid-utils'),
    parseGridAreas = _require.parseGridAreas,
    warnMissedAreas = _require.warnMissedAreas,
    prefixTrackProp = _require.prefixTrackProp,
    prefixTrackValue = _require.prefixTrackValue,
    getGridGap = _require.getGridGap,
    warnGridGap = _require.warnGridGap,
    inheritGridGap = _require.inheritGridGap;

function getGridRows(tpl) {
  return tpl.trim().slice(1, -1).split(/["']\s*["']?/g);
}

var GridTemplateAreas = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(GridTemplateAreas, _Declaration);

  var _super = _createSuper(GridTemplateAreas);

  function GridTemplateAreas() {
    _classCallCheck(this, GridTemplateAreas);

    return _super.apply(this, arguments);
  }

  _createClass(GridTemplateAreas, [{
    key: "insert",
    value:
    /**
     * Translate grid-template-areas to separate -ms- prefixed properties
     */
    function insert(decl, prefix, prefixes, result) {
      if (prefix !== '-ms-') return _get(_getPrototypeOf(GridTemplateAreas.prototype), "insert", this).call(this, decl, prefix, prefixes);
      var hasColumns = false;
      var hasRows = false;
      var parent = decl.parent;
      var gap = getGridGap(decl);
      gap = inheritGridGap(decl, gap) || gap; // remove already prefixed rows
      // to prevent doubling prefixes

      parent.walkDecls(/-ms-grid-rows/, function (i) {
        return i.remove();
      }); // add empty tracks to rows

      parent.walkDecls(/grid-template-(rows|columns)/, function (trackDecl) {
        if (trackDecl.prop === 'grid-template-rows') {
          hasRows = true;
          var prop = trackDecl.prop,
              value = trackDecl.value;
          trackDecl.cloneBefore({
            prop: prefixTrackProp({
              prop: prop,
              prefix: prefix
            }),
            value: prefixTrackValue({
              value: value,
              gap: gap.row
            })
          });
        } else {
          hasColumns = true;
        }
      });
      var gridRows = getGridRows(decl.value);

      if (hasColumns && !hasRows && gap.row && gridRows.length > 1) {
        decl.cloneBefore({
          prop: '-ms-grid-rows',
          value: prefixTrackValue({
            value: "repeat(".concat(gridRows.length, ", auto)"),
            gap: gap.row
          }),
          raws: {}
        });
      } // warnings


      warnGridGap({
        gap: gap,
        hasColumns: hasColumns,
        decl: decl,
        result: result
      });
      var areas = parseGridAreas({
        rows: gridRows,
        gap: gap
      });
      warnMissedAreas(areas, decl, result);
      return decl;
    }
  }]);

  return GridTemplateAreas;
}(Declaration);

GridTemplateAreas.names = ['grid-template-areas'];
module.exports = GridTemplateAreas;